import Checkbox from 'components/ui/base/checkbox/Checkbox';
import styled from 'styled-components';

export const StyledCheckbox = styled(Checkbox)`
    margin-left: 1.6rem;
`;
